/*
 * @Author: taowuhua
 * @:
 * @Date: 2024-11-18 09:50:41
 * @LastEditors: taowuhua
 * @LastEditTime: 2024-11-30 12:26:17
 * @Description: file content
 */
import axios from "axios"
import { Toast } from "vant"
// 创建axios实例
const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 36000,
})

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，例如添加请求头
    const token = localStorage.getItem("token")
    //TODO 上线的时候关闭
    // const token = "40af5493ebc04ad4b34cb048c9b49a45";

    if (token) {
      config.headers.token = token
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    const res = response.data
    // 根据后端定义的成功状态码判断请求是否成功，这里假设成功的code是200，可根据实际调整
    if (res.code === 200) {
      return res // 如果成功，返回真正的业务数据部分（去除外层的状态码、消息等包装）
    }
    // 根据环境变量判断是否为开发环境
    // if (process.env.NODE_ENV === 'development') {
    //     console.error('请求失败详细信息1：', res); // 在开发环境下，打印完整的返回数据，方便调试找问题
    //     Toast.fail(res.message || '请求失败，请稍后再试');
    // } else {
    //     Toast.fail(res.message || '请求失败，请稍后再试');
    // }
    return res
  },
  (error) => {
    // 处理网络错误或者接口返回的错误状态码情况
    let errMsg = ""
    if (error.response) {
      console.log(error)
      console.log(error.response)
      const { status } = error.response
      switch (status) {
        case 401:
          errMsg = "未授权，请重新登录"
          break
        case 404:
          errMsg = "请求的资源不存在"
          break
        case 500:
          errMsg = "服务器内部错误"
          break
        default:
          errMsg = `请求出错，状态码：${status}`
      }
    } else if (error.request) {
      errMsg = "网络连接异常，请检查网络设置"
    } else {
      errMsg = "请求设置出现错误"
    }
    // 根据环境变量判断是否为开发环境
    if (process.env.NODE_ENV === "development") {
      console.error("请求出错详细信息2：", error) // 在开发环境下，打印完整的错误信息，方便调试
      Toast.fail(errMsg)
    } else {
      Toast.fail(errMsg)
    }
    return Promise.reject(new Error(errMsg))
  }
)
// 请求拦截器
http.interceptors.request.use(
  (config) => {
    //...其他请求头设置逻辑

    // 手动设置临时的X-Access-Token值用于调试，仅在开发环境下生效，可根据实际情况调整
    if (process.env.NODE_ENV === "development") {
      //TODO 上线的时候关闭
      // config.headers["token"] ="40af5493ebc04ad4b34cb048c9b49a45"
      // config.headers["token"] = localStorage.getItem("token")
      config.headers.token = token
    }

    return config
  },
  (error) => {
    //...
  }
)
export default http
